export default __webpack_public_path__ + "static/media/ultraflo.524ba5ac.png";